export default "__VITE_ASSET__DTjRu8OJ__"